import { Typography } from "@/components/common/Typography/Typography"
import { classNames } from "@/utils/classNames"
import { Layout, LayoutProps } from ".."

interface MainLayoutProps extends LayoutProps {
  contentCenter?: React.ReactElement
  contentRight?: React.ReactElement
  title?: string
  titleInHeader?: boolean
}

export const MainLayout: React.FC<MainLayoutProps> = ({
  title,
  contentCenter,
  contentRight,
  headerLeftElement,
  headerRightElement,
  titleInHeader = false,
}) => {
  const renderTitle = (
    <Typography as="h1" variant="titleM" className="pb-L">
      {title}
    </Typography>
  )

  const headerTitle = title ? (
    <Typography as="h2" variant="textM">
      {title}
    </Typography>
  ) : null

  const combinedHeaderLeftElement = titleInHeader ? (
    <div className="flex min-w-0 items-center gap-3">
      {headerTitle}
      {headerLeftElement ? headerLeftElement : null}
    </div>
  ) : (
    headerLeftElement
  )

  return (
    <Layout
      headerLeftElement={combinedHeaderLeftElement}
      headerRightElement={headerRightElement}
    >
      <div className={classNames("flex h-full min-w-0 flex-row")}>
        <div
          className="min-w-0 flex-1 overflow-y-auto px-XXL py-L"
          data-scroll-container
        >
          {title && !titleInHeader ? renderTitle : null}
          {contentCenter}
        </div>

        {contentRight ? (
          <div
            className={classNames("h-full w-[300px]", "bg-grey1", "px-M py-L")}
          >
            {contentRight}
          </div>
        ) : null}
      </div>
    </Layout>
  )
}
